// extracted by mini-css-extract-plugin
export var banner = "_fl-0";
export var closeButton = "_fl-2";
export var greenCheckmark = "_fl-3";
export var hereLink = "_fl-4";
export var titleIcon = "_fl-1";